var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12470_303022)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2856 12.9489H23.551C23.9542 12.9489 24.3273 13.1612 24.5334 13.5076C24.7394 13.854 24.7476 14.2833 24.5554 14.6375C22.9885 17.521 20.6479 20.163 17.6141 21.9974C16.6212 22.5977 15.3786 22.5978 14.3857 21.9975C11.3517 20.1632 9.01112 17.521 7.44433 14.6374C7.25192 14.2833 7.26024 13.854 7.46625 13.5076C7.67226 13.1612 8.04549 12.9489 8.44853 12.9489H13.7142V2.40096C13.7142 1.13858 14.7375 0.115234 15.9999 0.115234C17.2622 0.115234 18.2856 1.13858 18.2856 2.40096V12.9489Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28376 21.5947C3.54613 21.5947 4.56947 22.6181 4.56947 23.8806V25.7864C4.56947 26.1119 4.71052 26.4774 5.05198 26.7857C5.40115 27.1011 5.92026 27.3128 6.50421 27.3128H25.4963C26.0803 27.3128 26.5994 27.1011 26.9484 26.7857C27.2899 26.4774 27.4309 26.1119 27.4309 25.7864V23.8806C27.4309 22.6181 28.4542 21.5947 29.7166 21.5947C30.979 21.5947 32.0023 22.6181 32.0023 23.8806V25.7864C32.0023 27.4831 31.2542 29.0568 30.0126 30.1782C28.7788 31.2927 27.1509 31.8842 25.4963 31.8842H6.50421C4.84951 31.8842 3.22163 31.2927 1.98782 30.1782C0.746304 29.0568 -0.00195312 27.4831 -0.00195312 25.7864V23.8806C-0.00195312 22.6181 1.0214 21.5947 2.28376 21.5947Z",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12470_303022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))));
};
export default SvgDownload;